'use client';

import { statusTypes, usePollingStore } from '../lib/pollingStore.js';
import Icon, { ICON_TYPE } from '../components/base/icon.js';
import useContentWizardContext from '../contentWizard/contentWizardContext.js';
import useEditorContext from '../context/editorContext.js';
import { Classes } from '@blueprintjs/core';
import useAncestryFamilyTreeContext from '../context/ancestryFamilyTreeContext.js';
import { useMemo } from 'react';

export const RecordsBadge = ({ editorItem, className, style }) => {
  const status = usePollingStore(state => state.status);
  const pollingData = usePollingStore(state => state.data);
  const contentWizardContext = useContentWizardContext();
  const editorContext = useEditorContext();

  const { projectPersons } = useAncestryFamilyTreeContext();

  const personsWithCitations = useMemo(() => {
    return (projectPersons ?? []).filter(p => p.hasCitations)
  }, [projectPersons])

  const handleRecordsClick = (e) => {
    e.preventDefault();

    contentWizardContext.openDialog({
      type: 'records',
      selectedPersons: personsWithCitations,
      onAddPages: recordPages => {
        editorContext.addPages(editorItem.id, recordPages, { sortByTags: true });
        contentWizardContext.closeDialog();
        try {
          gtag('event', 'add_records_done', {
            event_category: 'editor',
            event_label: recordPages.length,
          });
        } catch (e) { }
      },
    });
  }

  // Use polling store if available, fallback to draft data
  const citationsCount = status === statusTypes.SUCCESS
    ? pollingData?.CitationsCount
    : editorItem?.additionalInfo?.CitationsCount;

  if (citationsCount > 0 && personsWithCitations.length > 0) {
    return (
      <div className={className} style={{ display: 'flex', alignItems: 'center', ...style }}>
        <Icon type={ICON_TYPE.LEAF} width={20} height={20} />
        <span style={{ paddingLeft: 4 }}>We found <a href="" onClick={handleRecordsClick} className={Classes.POPOVER_DISMISS}>records</a> that you can use in your book.</span>
      </div>
    );
  }

  return null;
}
